import { RouteHelpers } from '@/mixins';
import { Configuration } from '@/types';
import ConfigurationTreeView from '@/components/configuration/TreeView.vue';
import { TreeViewConstants } from '@/types/constants/TreeViewConstants';

const ScriveAfterSignMappingsManagement = () =>
  import(
    /* webpackChunkName: "ScriveAfterSignMappings" */
    '@/views/configuration/scrive/ScriveAfterSignMappingsManagement.vue'
  );

const ScriveEditTemplateAfterSignMappings = () =>
  import(
    /* webpackChunkName: "ScriveEditTemplateAfterSignMappings" */
    '@/views/configuration/scrive/ScriveEditTemplateAfterSignMappings.vue'
  );

const meta = {
  layout: 'TreeView',
  treePath: 'scriveaftersignmappings',
  treeViewKey: TreeViewConstants.Keys.Configuration,
  title: 'Scrive After Sign Mappings'
};

export const AfterSignActionRoutes = [
  {
    ...Configuration.Scrive.AfterSignMapping.Management,
    components: {
      default: ScriveAfterSignMappingsManagement,
      treeView: ConfigurationTreeView
    },
    meta
  },
  {
    ...Configuration.Scrive.AfterSignMapping.Edit,
    components: {
      default: ScriveEditTemplateAfterSignMappings,
      treeView: ConfigurationTreeView
    },
    meta: {
      ...meta,
      model: 'scriveaftersign'
    },
    beforeEnter: (to: any, from: any, next: any) => {
      RouteHelpers.setErrorPageRedirect(Configuration.Scrive.AfterSignMapping.Management.name);
      RouteHelpers.beforeEnterCheckRouteParamAsNumeric(to, from, next, ['id']);
    }
  }
];
